// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1464":"011f537e","4307":"3e38e8c2","7504":"7388a7e5"}[chunkId] + ".chunk.css";
};